export default __webpack_public_path__ + "36cd3f1efd8353ab3851d53b78245732.glb";